<template>
  <v-card tile flat class="grey lighten-4 rounded-t-xl">
    <v-card flat class="transparent">
      <v-card-title>
        {{ $t('customer.comment') }}
        <v-spacer />
        <v-btn icon @click="close">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
    </v-card>
    <v-container>
      <v-row dense>
        <v-col cols="12">
          <v-textarea
            v-model="customerComment"
            :label="$t('customer.comment') + ' (' + $t('optional') + ')'"
            outlined
            hide-details
          />
        </v-col>
      </v-row>
    </v-container>
    <v-container class="px-4 pt-2 pb-4" fluid>
      <v-btn
        rounded
        large
        block
        depressed
        dark
        color="#2979FF"
        height="44"
        class="text-none"
        @click="logComment"
      >
        <span>
          {{ $t('buttons.logComment') }}
        </span>
      </v-btn>
    </v-container>
  </v-card>
</template>

<script>
export default {
	name: "CustomerComment",
	computed: {
		accentColor() {
			return this.$store.state.accentColor
		},
		customerComment: {
			get() {
				return this.$store.state.customerComment
			},
			set(comment) {
				comment = this.$store.getters.pruneEmojisFromText(comment)
				this.$store.commit('updateCustomerComment', comment)
			}
		},
	},
	methods: {
		close() {
			this.$store.commit('updateShowCustomerComment', false)
		},
		logComment: function() {
			this.$store.commit('updateShowCustomerComment', false);
		},
	}
}
</script>

<style scoped>

</style>
